"use client";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import {
  BUTTON_SIZES_MAP,
  BUTTON_STYLED_PROPS,
  BUTTON_TYPOGRAPHY,
} from "../../constants";

type BaseStyledButtonProps = {
  $size: keyof typeof BUTTON_SIZES_MAP;
  $loading: boolean;
  $disabled: boolean;
};

export const BaseStyledButton = styled("button", {
  shouldForwardProp: prop =>
    !BUTTON_STYLED_PROPS.base.includes(prop as keyof BaseStyledButtonProps),
})<BaseStyledButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ $size }) => BUTTON_SIZES_MAP[$size].height};
  padding: ${({ $size }) => BUTTON_SIZES_MAP[$size].padding};
  gap: ${({ $size }) => BUTTON_SIZES_MAP[$size].gap};
  border-radius: ${({ $size }) => BUTTON_SIZES_MAP[$size].radius};
  & .octolane-button-text {
    font-size: ${BUTTON_TYPOGRAPHY.size};
    font-weight: ${BUTTON_TYPOGRAPHY.weight};
    line-height: ${BUTTON_TYPOGRAPHY.lineHeight};
    letter-spacing: ${BUTTON_TYPOGRAPHY.spacing};
  }
  &:focus {
    outline: none;
  }
  &:focus-visible {
    outline: none;
  }
  &:disabled {
    cursor: not-allowed;
  }

  ${({ $loading, $disabled }) =>
    ($loading || $disabled) &&
    css`
      cursor: not-allowed;
    `}
`;
